import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JsonHttpService } from '../../shared/http/json-http.service';
import { BarCurveValue, ChartConfigurationWrapper, PieValue, GridValue } from '../models';

@Injectable({
    providedIn: 'root'
})
export class ChartService {
    constructor(private httpService: JsonHttpService) { }

    getConfigurations(): Promise<ChartConfigurationWrapper[]> {
        return this.httpService.get('/api/charts/get-chart-configurations').toPromise();
    }

    getPieValues(configurationId: number): Promise<PieValue[]> {
        const options = { params: new HttpParams().set('configurationId', `${configurationId}`) };
        return this.httpService.get('/api/charts/get-pie-values', options).toPromise();
    }

    getBarCurveValues(configurationId: number): Promise<BarCurveValue[]> {
        const options = { params: new HttpParams().set('configurationId', `${configurationId}`) };
        return this.httpService.get('/api/charts/get-bar-values', options).toPromise();
    }

    getGridValues(configurationId: number): Promise<GridValue[]> {
        const options = { params: new HttpParams().set('configurationId', `${configurationId}`) };
        return this.httpService.get('/api/charts/get-grid-values', options).toPromise();
    }
}
